var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExclusiveMilestone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2361 2.17311C20.3276 1.54291 21.6724 1.54291 22.7639 2.17311L36.4226 10.0589C37.5141 10.6891 38.1865 11.8538 38.1865 13.1142V28.8858C38.1865 30.1462 37.5141 31.3109 36.4226 31.9411L22.7639 39.8269C21.6724 40.4571 20.3276 40.4571 19.2361 39.8269L5.5774 31.9411C4.48587 31.3109 3.81347 30.1462 3.81347 28.8858V13.1142C3.81347 11.8538 4.48587 10.6891 5.5774 10.0589L19.2361 2.17311Z",
    fill: "url(#paint0_linear_577_28340)",
    stroke: "url(#paint1_linear_577_28340)",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9136 27L16.7207 21.2829V19.9356H17.785C18.2107 19.9356 18.5832 19.8749 18.9025 19.7535C19.2336 19.62 19.5056 19.4318 19.7185 19.1891C19.9432 18.9463 20.0969 18.655 20.1797 18.3151H16.7207V16.9678H20.1619C20.091 16.6522 19.9668 16.373 19.7894 16.1303C19.6239 15.8875 19.3992 15.6993 19.1154 15.5658C18.8434 15.4202 18.5123 15.3473 18.122 15.3473H16.7207V14H24.7207V15.3473H21.9358C22.1368 15.578 22.3024 15.8268 22.4325 16.0938C22.5744 16.3609 22.669 16.6522 22.7163 16.9678H24.7207V18.3151H22.7517C22.6335 19.2134 22.2965 19.9174 21.7407 20.4272C21.1849 20.9248 20.4694 21.2647 19.5943 21.4468L23.071 27H19.9136Z",
    fill: "url(#paint2_linear_577_28340)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_577_28340",
    x1: 21.0001,
    y1: -0.903604,
    x2: 21.0001,
    y2: 42.9036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#11101F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4978"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_577_28340",
    x1: 5.25,
    y1: 8.75,
    x2: 29.75,
    y2: 34.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B85CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDBADF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_577_28340",
    x1: 17.7207,
    y1: 16.7083,
    x2: 24.5991,
    y2: 21.0924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B85CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDBADF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclusiveMilestone);
export default __webpack_public_path__ + "static/media/exclusive_milestone.bf2d6af446f79dfe8b3b11962fc6230f.svg";
export { ForwardRef as ReactComponent };